import { useCreateEntityElement } from 'publisher/context/create-entity-element-context'
import { usePage } from 'publisher/store'
import { getChildrenEntities } from 'publisher/store/page/pageSelectors'
import React, { memo } from 'react'
import { CommonWebsiteLayoutBody } from 'src/shared/entities/website-layout-body'
import { WebsiteLayoutBodyInterface } from 'src/shared/types/website-entities'

export interface WebsiteLayoutBodyProps {
  entity: WebsiteLayoutBodyInterface
}

export const WebsiteLayoutBody = memo(({ entity }: WebsiteLayoutBodyProps) => {
  const createEntityElement = useCreateEntityElement()
  const layoutEntities = usePage(page =>
    getChildrenEntities(page, entity.childIds),
  )

  const header = createEntityElement(layoutEntities[0])
  const footer = createEntityElement(layoutEntities[1])
  const content = createEntityElement(layoutEntities[2])

  return (
    <CommonWebsiteLayoutBody
      header={header}
      content={content}
      footer={footer}
    />
  )
})
